/** Taux de TVA par défaut en Tunisie */
export const DEFAULT_TAX_RATE = 0.19;

/** Remise maximale autorisée — décision PO : 20% */
export const MAX_DISCOUNT_PCT = 20;

/** Validité d'une offre en jours */
export const OFFER_VALIDITY_DAYS = 60;

/** Durée de vie du cache catalogue en heures */
export const CATALOG_CACHE_TTL_HOURS = 12;

/** Intervalle de synchronisation automatique en heures */
export const SYNC_INTERVAL_HOURS = 4;

/** Nombre de jours avant expiration pour déclencher les alertes */
export const RENEWALS_ALERT_DAYS = 30;

/** Préfixe des références d'offres */
export const OFFER_REFERENCE_PREFIX = 'OFF';

/** Nombre de lignes par page dans les DataGrid */
export const ROWS_PER_PAGE = 25;

/** Clés des paramètres stockés dans cr_crm_setting */
export const SETTING_KEYS = {
  FLOW_URL_SYNC_CLIENTS: 'flow_url_sync_clients',
  FLOW_URL_GENERATE_PDF: 'flow_url_generate_pdf',
  FLOW_URL_SEND_OFFER: 'flow_url_send_offer',
  DEFAULT_TAX_RATE: 'default_tax_rate',
  COMPANY_NAME: 'company_name',
  COMPANY_ADDRESS: 'company_address',
  COMPANY_LOGO_URL: 'company_logo_url',
  VAT_ENABLED: 'vat_enabled',
} as const;
